import { render, staticRenderFns } from "./MotionHistory.vue?vue&type=template&id=6cf8a750&scoped=true&"
import script from "./MotionHistory.vue?vue&type=script&lang=js&"
export * from "./MotionHistory.vue?vue&type=script&lang=js&"
import style0 from "./MotionHistory.vue?vue&type=style&index=0&id=6cf8a750&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf8a750",
  null
  
)

export default component.exports